import { Box, Button, Stack, Typography } from "@mui/material";
import { Link, useLocation } from "react-router-dom";

export function NotFoundPage() {
  const location = useLocation();
  return (
    <Stack flexDirection="column" alignItems="center" justifyContent="center" textAlign="center" marginTop={10}>
      <Box title="Phoenix was here!" sx={{ fontSize: 64 }}>
        🪶
      </Box>
      <Typography variant="h4">Oops! Page not found.</Typography>
      <Typography variant="body1" mt={1}>
        404 Not Found - Unable to find a page at '{String(location.pathname)}'
      </Typography>
      <Typography paddingY={4} fontSize={18}>
        Please double check the URL and try again.
      </Typography>
      <Button component={Link} to="/" variant="contained" sx={{ minWidth: 200 }}>
        Return home
      </Button>
    </Stack>
  );
}
